import { useContext, useEffect, useState } from 'react';
import { Appearance, PaymentIntent } from '@stripe/stripe-js';
import { usePaymentApiV1 } from '../../../../clients/quipli-service/payment/payment-api-v1';
import { Elements } from '@stripe/react-stripe-js';
import { Spinner } from '../../../../components/spinner/spinner';
import { StripeContext } from '../../../../context/stripe-context';
import { useCustomer } from '../../../../hooks/use-customer-context';
import { Payment, PaymentMethod, PaymentMethodType } from '../../../../clients/quipli-service/payment/payment';
import { UserAddress } from '../../../../clients/quipli-service/user/user';

export default function StripeInit({
  amount,
  setPaymentIntent,
  onConfirmPayment,
  currency,
  address,
  setPayment,
}: {
  amount: number;
  setPaymentIntent: (paymentIntent: PaymentIntent) => void;
  onConfirmPayment: (paymentMethod: PaymentMethod) => void;
  currency: string;
  address: UserAddress;
  setPayment: (payment: Payment) => void;
}) {
  const customer = useCustomer();
  const stripe = useContext(StripeContext);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { createPaymentIntent } = usePaymentApiV1();

  const [paymentData, setPaymentData] = useState<{ paymentIntent: string; clientSecret: string; url: string }>();

  useEffect(() => {
    async function getPaymentIntent() {
      const { paymentIntent, url, payment } = await createPaymentIntent(amount, currency, address);
      if (!paymentIntent.client_secret) throw new Error('No client secret returned');
      setPaymentData({
        paymentIntent: paymentIntent.id,
        clientSecret: paymentIntent.client_secret,
        url: url,
      });
      setPaymentIntent(paymentIntent);
      setPayment(payment);
      onConfirmPayment({
        type: PaymentMethodType.Stripe,
        method: 'affirm',
        paymentIntentId: paymentIntent.id,
      });
      setIsLoading(false);
    }

    if (customer) {
      getPaymentIntent();
    }
  }, [amount, customer]);

  const appearance: Appearance = {
    theme: 'stripe',
  };

  return isLoading || !customer || !paymentData ? (
    <Spinner></Spinner>
  ) : (
    <>
      <Elements
        options={{ appearance, clientSecret: paymentData.clientSecret }}
        stripe={stripe}
        key={paymentData.clientSecret}
      />
    </>
  );
}
